import { Promotion_service } from "./../services/Promotion.service"
import { Operator_service } from "../services/Operator_service"
import router from "../router/router"
import { MessageBox, Loading } from 'element-ui'
import moment from 'moment'
import Cookie from "cookies-js"

const month_th = ['มกราคม','กุมภาพันธ์','มีนาคม','เมษายน','พฤษภาคม','มิถุนายน','กรกฎาคม','สิงหาคม','กันยายน','ตุลาคม','พฤศจิกายน','ธันวาคม']
const state = {
    fileType: '',
    dialogVisible: false,
    path_excel: null,
    monthly: null,
    month_title : null,
    saveRow: [],
    fileForm: null,
    PreviewRows: [],
    errors: [],
    data_table: [],
    total: 0,
    loading: true,
    provider: [],
    historyHeader: null,
    histories : {},
    schema_th : {},
    schema_en : {},
    regulates : [],
    averages : {},
    proportion_main_ontop : {},
    proportion_min_sec : {},
    total_min_sec : {},
    alert_status : {
        min_sec : 'success',
        regulate : 'warning'
    },
    missings : [],
    row_detail: {},
    deleted_by: {},
    btn_disable : false,
    regulate_list : []
}

const actions = {
    async addPromotion({ commit }, data) {
        commit('BTN_DISABLE', true)
        let result = await Promotion_service.addPromotion(data);
        if (result.status === 200) {
            MessageBox.confirm('จัดเก็บข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                router.push({ name: 'Manage_mobileOperator' })
            }).catch(() => {
                router.push({ name: 'Manage_mobileOperator' })
            });
            commit('BTN_DISABLE', false)
        } else {
            commit('BTN_DISABLE', false)
            MessageBox.confirm(result.data[0], 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async submitUpload({ state }) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        var result = await Promotion_service.savePdf({ 
            path: state.fileForm.path,
            type: state.fileForm.type,
            monthly_regulate : state.monthly
        }) 
        if (result.status === 200) {
            setTimeout(function(){ loadingInstance.close() }, 250);
            MessageBox.confirm('จัดเก็บข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                router.push({ name: 'Operator_Manage_mobile' })
            })
        } else {
            setTimeout(function(){ loadingInstance.close() }, 250);
            state.errors = result.data.err;
            router.push({ name: "Alert_promotion_mobile" });
        }
    },
    async submitUploadMonthly({ state }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result =  await Promotion_service.importPromotions(state.fileForm)
        if(result.status === 200){
            setTimeout(function(){ loadingInstance.close() }, 250);
            MessageBox.confirm('จัดเก็บข้อมูลเรียบร้อย', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(() => {
                router.push({ name: 'Upload_saveMonthly' })
            })
        }else{
            alert(result.data.message)
            router.push({ name: 'Upload_saveMonthly' })
        }
    },
    async previewPromotions({ commit,state }, data) {
        commit('LOADING',true)
        router.push({name: "Confirm_promotion_Monthlymobile"})
        let regulate = await Promotion_service.getServiceRegulate()
        let main_ontop = await Promotion_service.getProportionMobileRate()
        let min_sec = await Promotion_service.getProportionMobileType()
        let result = await Promotion_service.previewPromotions(data);
        if (result.status === 200) {
            commit('SET_FILE_TYPE', result.data.filetype)
            commit('SET_FILE_FORM', {
                path : result.data.file_path,
                type : result.data.filetype,
                month : moment(state.monthly).format('YYYY-MM-DD'),
                missings : result.data.missings
            })
            commit('SET_ERRORS', result.data.err)
            commit('SET_DATA_TABLE', result.data.promotions)
            commit('SET_SCHEMA',{schema_th : result.data.schema_th, schema_en : result.data.schema_en})
            commit('LOADING',false)
            commit('SET_MONTH_TITLE',state.monthly)
            commit('SET_AVERAGE_DATA',{
                avg : result.data.avg,
                rgl : regulate.data,
                ppt_main_ontop : main_ontop.data[0],
                ppt_min_sec : min_sec.data[0],
                service_type : result.data.service_type
            })
            commit('SET_MISSINGS_DATA',result.data.missings)
        } else {
            MessageBox.confirm(result.data.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            }).then(()=>{
                router.push({name: 'Add_uploadsave'})
            }).catch(()=>{
                router.push({name: 'Add_uploadsave'})
            })
        }
    },
    async setProvider({ commit }, data) {
        let result = await Promotion_service.setProvider();
        if (result.status === 200) {
            state.provider = [];
            state.provider = result.data;
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async searchPromotion({ commit }, formdata) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        commit('LOADING', true)
        let result = await Promotion_service.searchPromotion(formdata);
        if (result.status === 200) {
            state.total = result.data.length > 0 ? result.data[0].total : 0
            commit('SET_TABLE', result.data)
            setTimeout(()=>{
                commit('LOADING', false)
                loadingInstance.close()
            }, 250)
        } else {
            setTimeout(()=>{
                commit('LOADING', false)
                loadingInstance.close()
            }, 250)
            if (result.status === 230 || result.status === 225) {
                MessageBox.confirm(result.message, 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'warning'
                }).then(() => {
                    $cookies.remove('user_nbtc')
                    router.push({ name: 'Login' })
                }).catch(() => {
                    $cookies.remove('user_nbtc')
                    router.push({ name: 'Login' })
                });
            } else {
                MessageBox.confirm(result.message, 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'warning'
                }).then(() => {}).catch(() => {});
            }
        }
    },
    async searchPopularPromotion({commit}, data) {
        state.loading = true
        if(data.form.month_year){
            let start = moment(data.form.month_year).format('YYYY-MM-DD');
            let end = moment(data.form.month_year).add(1, 'M');
            end = moment(end).subtract(1, 'd').format('YYYY-MM-DD');
            data.form.dateRange[0] = start;
            data.form.dateRange[1] = end;
        } else {
            let start = moment(data.form.dateRange[0]).date(1).format('YYYY-MM-DD');
            let end = moment(start).add(1, 'M');
            end = moment(end).subtract(1, 'd').format('YYYY-MM-DD');
            data.form.dateRange[0] = start;
            data.form.dateRange[1] = end;
        }
        let result = await Promotion_service.searchPopularPromotion(data);
        if (result.status === 200) {
            if (result.data.length > 0)
                state.total = result.data[0].total
            else
                state.total = 0;

            commit('SET_TABLE', result.data)
        } else {
            if (result.status === 230 || result.status === 225) {
                MessageBox.confirm(result.message, 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'warning'
                }).then(() => {
                    $cookies.remove('user_nbtc')
                    router.push({ name: 'Login' })
                }).catch(() => {
                    $cookies.remove('user_nbtc')
                    router.push({ name: 'Login' })
                });
            } else {
                MessageBox.confirm(result.message, 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'warning'
                }).then(() => {}).catch(() => {});
            }
        }
    },
    async removePromotion({ commit }, id) {
        let result = await Promotion_service.removePromotion({ promotion_id: id });
        if (result.status === 200) {
            commit('CUT_TABLE', id)
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async findHistory({ commit }, data) {
        let result = await Promotion_service.findHistory(data);
        if(result.status === 200){
            if(!result.data.diffs.length){
                MessageBox.confirm('ไม่พบประวัติการแก้ไข', 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'warning'
                })
            }else{
                commit('SET_HISTORY_DATA',result.data)
                let regex = /Operator\/Manage_mobile/
                let path = regex.test(router.currentRoute.path) ? 'History_mobileOper' : 'History_mobileAdmin'
                router.push({ name: path })
            }
        }
    },
    async setObjExcel({ state,commit }, data) {
        let loadingInstance = Loading.service({ fullscreen: true, text: "ระบบกำลังประมวลผล กรุณารอสักครู่ ...", background: "rgb(0, 0, 0,0.6)" });
        let result = await Promotion_service.setObjExcel(data);
        if (result.status === 200) {
            setTimeout(function(){ loadingInstance.close() }, 250);
            commit('UPDATE_ROW', result.data)
        } else {
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async sendRequest({commit}, formdata){ //OPERATOR REQUEST FOR EDITING
        let userinfo = JSON.parse(Cookie.get('user_nbtc'))
            formdata.operator_id = userinfo.admin_id
            formdata.provider_id = userinfo.provider_id
        let result = await Promotion_service.sendRequest(formdata)
        if(result.status == 200){
            MessageBox.confirm('ส่งคำร้องเรียบร้อยแล้ว', 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'success'
            }).then(()=>{
                commit('SET_CR_STATUS',{promotion_id : formdata.promotion_id, cr_status : 'request'})
            })
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async getProviderList({commit}, provider_type){
        let result = await Operator_service.getProviderList(provider_type)
        if(result.status == 200){
            commit('SET_PROVIDER_LIST', result.data)
        }else{
            MessageBox.confirm(result.message, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async getRegulateList({commit}){
        let userinfo = await JSON.parse(Cookie.get('user_nbtc'))
        let result = await Promotion_service.getAvailableMonthlyRegulate({ 'provider_id' : userinfo.provider_id})
        if(result.status == 200){
            commit('SET_REGULATE_LIST', result.data)
        }else{
            MessageBox.confirm(result.data, 'แจ้งเตือน', {
                confirmButtonText: 'ตกลง',
                showCancelButton: false,
                type: 'warning'
            })
        }
    },
    async create_export_data({state}){
        var tmp = []
        for(let item of state.errors){
            tmp.push({
                'แถว' : item.row,
                'รหัสรายการส่งเสริมการขาย' : state.PreviewRows[item.row-9].promotion_code,
                'ชื่อคอลัมน์' : state.schema_th[item.col],
                'ข้อมูล' : state.PreviewRows[item.row-9][state.schema_en[item.col]],
                'คำอธิบาย' : item.detail || `พบการเปลี่ยนแปลงข้อมูล
ข้อมูลเดิม : ${item.old}
ข้อมูลใหม่ : ${item.new}`,
            })
        }
        return tmp
    },
    async set_edit_promotion_detail({commit}, revision_id){
        let result = await Promotion_service.getPromotionByRevision({revision_id})
        if(result.status === 200){
            if(result.data.length){
                let item = result.data[0]
                item.start_sale_date = item.start_sale_date ? moment(item.start_sale_date).add(543,'Y').format('DD/MM/YYYY') : null
                item.end_sale_date = item.end_sale_date ? moment(item.end_sale_date).add(543,'Y').format('DD/MM/YYYY') : null
                item.start_service_date = item.start_service_date ? moment(item.start_service_date).add(543,'Y').format('DD/MM/YYYY') : null
                item.end_service_date = item.end_service_date ? moment(item.end_service_date).add(543,'Y').format('DD/MM/YYYY') : null
                commit('SET_EDIT_ROW', item)
                router.push({ name: "Edit_promotion_mobile" })
            }else{
                MessageBox.confirm('ไม่พบข้อมูล', 'แจ้งเตือน', {
                    confirmButtonText: 'ตกลง',
                    showCancelButton: false,
                    type: 'warning'
                })
            }
        }else{
            alert(result.data)
        }
    }
}

const mutations = {
    SET_TABLE(state, data) {
        let promotion = data
        // Note: Using sync forEach instead of async to ensure proper Vue reactivity
        promotion.forEach(function(val){
            val.created_at = moment(val.created_at).add(543, 'y').format('DD/MM/YYYY')
            val.start_sale_date = val.start_sale_date ? moment(val.start_sale_date).add(543, 'y').format('DD/MM/YYYY') : null
            val.end_sale_date = val.end_sale_date ? moment(val.end_sale_date).add(543, 'y').format('DD/MM/YYYY') : null
            val.start_service_date = val.start_service_date ? moment(val.start_service_date).add(543, 'y').format('DD/MM/YYYY') : null
            val.end_service_date = val.end_service_date ? moment(val.end_service_date).add(543, 'y').format('DD/MM/YYYY') : null
            val.deleted_at = val.deleted_at ? moment(val.deleted_at).add(543, 'y').format('DD/MM/YYYY') : null
            val.service_charge_type = val.service_charge_type ? val.service_charge_type.toLowerCase() : null
        })
        state.data_table = promotion
        state.loading = false
    },
    CUT_TABLE(state, id) {
        let index = state.data_table.findIndex(x => x.promotion_id == id);
        state.data_table.splice(index, 1)
    },
    CHANGE_FileForm(state, data) {
        state.fileForm = null;
        state.fileForm = data
    },
    CHANGE_dateMonthly(state, data) {
        state.monthly = data
    },
    SET_HISTORY_DATA(state,qrydata){
        state.histories = qrydata.diffs
        state.historyHeader = qrydata.promotion_name
    },
    LOADING(state,status){
        state.loading = status
    },
    SET_DATA_TABLE(state, data){
        state.PreviewRows = data
    },
    SET_SCHEMA(state,result){
        state.schema_th = result.schema_th
        state.schema_en = result.schema_en
    },
    SET_FILE_FORM(state, fileForm){
        state.fileForm = fileForm
    },
    SET_ERRORS(state, data){
        state.errors = data
    },
    SET_MONTH_TITLE(state, month){
        state.month_title = month_th[moment(month).month()]+' ปี พ.ศ. '+moment(month).add(543,'Y').format('YYYY')
    },
    SET_AVERAGE_DATA(state, data){
        state.proportion_main_ontop = data.ppt_main_ontop
        state.proportion_min_sec = data.ppt_min_sec
        for(let sv in data.avg.main){
            data.avg['main'][sv] = data.avg['main'][sv].length > 0 ? eval(data.avg['main'][sv].join('+')) / data.avg['main'][sv].length : null
            data.avg['on-top'][sv] = data.avg['on-top'][sv].length > 0 ? eval(data.avg['on-top'][sv].join('+')) / data.avg['on-top'][sv].length : null
        }
        let main_voice = data.avg['main'].voice_per_minute
        let ontop_voice = data.avg['on-top'].voice_per_minute
        let voice = ontop_voice ? main_voice*(data.ppt_main_ontop.proportion_main_promotion*0.01)+ontop_voice*(data.ppt_main_ontop.proportion_ontop_promotion*0.01) : main_voice
        let sms = data.avg['on-top'].sms_per_message 
                ? data.avg['main'].sms_per_message*(data.ppt_main_ontop.proportion_main_promotion*0.01)+data.avg['on-top'].sms_per_message*(data.ppt_main_ontop.proportion_ontop_promotion*0.01) 
                : data.avg['main'].sms_per_message
        let mms = data.avg['on-top'].mms_per_message 
                ? data.avg['main'].mms_per_message*(data.ppt_main_ontop.proportion_main_promotion*0.01)+data.avg['on-top'].mms_per_message*(data.ppt_main_ontop.proportion_ontop_promotion*0.01) 
                : data.avg['main'].mms_per_message
        let internet = data.avg['on-top'].internet_per_MB
                ? data.avg['main'].internet_per_MB*(data.ppt_main_ontop.proportion_main_promotion*0.01)+data.avg['on-top'].internet_per_MB*(data.ppt_main_ontop.proportion_ontop_promotion*0.01) 
                : data.avg['main'].internet_per_MB
        state.total_min_sec = {
            minute : data.service_type.minute,
            second : data.service_type.second,
            minute_percent : (data.service_type.minute/(data.service_type.minute+data.service_type.second)*100).toFixed(2),
            second_percent : (data.service_type.second/(data.service_type.minute+data.service_type.second)*100).toFixed(2),
        }
        state.alert_status.min_sec = data.ppt_min_sec.proportion_second <= (data.service_type.second/(data.service_type.minute+data.service_type.second)*100) ? 'success' : 'warning'
        voice = voice > 0 ? parseFloat(voice.toFixed(3)) : ''
        sms = sms > 0 ? parseFloat(sms.toFixed(3)) : ''
        mms = mms > 0 ? parseFloat(mms.toFixed(3)) : ''
        internet = internet > 0 ? parseFloat(internet.toFixed(3)) : ''
        state.averages = {
            'บริการเสียง' : voice,
            'บริการ SMS' : sms,
            'บริการ MMS' : mms,
            'บริการอินเทอร์เน็ต' : internet,
        }
        let rg = data.rgl.pop()
        state.regulates = {
            'บริการเสียง' : { value : rg.voice_service_rate.toFixed(2) , status : (voice >= 0 ? rg.voice_service_rate >= voice ? '✓' : 'X' : '')},
            'บริการ SMS' : { value : rg.sms_service_rate.toFixed(2) , status : (sms >= 0 ? rg.sms_service_rate >= sms ? '✓' : 'X' : '')},
            'บริการ MMS' : { value : rg.mms_service_rate.toFixed(2) , status : (mms >= 0 ? rg.mms_service_rate >= mms ? '✓' : 'X' : '')},
            'บริการอินเทอร์เน็ต' : { value : rg.internet_service_rate.toFixed(2) , status : (internet >= 0 ? rg.internet_service_rate >= internet ? '✓' : 'X' : '')},
        }
        state.alert_status.regulate = JSON.stringify(state.regulates).includes('X') ? 'warning' : 'success'
    },
    SET_MISSINGS_DATA(state, data){
        state.missings = Object.keys(data)
    },
    SET_CR_STATUS(state, item_info){
        for(let index in state.data_table){
            if(state.data_table[index].promotion_id == item_info.promotion_id) state.data_table[index].cr_status = item_info.cr_status
        }
    },
    SET_EDIT_ROW(state, row){
        row.start_sale_date = moment(row.start_sale_date,'DD/MM/YYYY').subtract(543,'Y').format('YYYY-MM-DD')
        row.end_sale_date = row.end_sale_date ? moment(row.end_sale_date,'DD/MM/YYYY').subtract(543,'Y').format('YYYY-MM-DD') : null
        row.start_service_date = moment(row.start_service_date,'DD/MM/YYYY').subtract(543,'Y').format('YYYY-MM-DD')
        row.end_service_date = row.end_service_date ? moment(row.end_service_date,'DD/MM/YYYY').subtract(543,'Y').format('YYYY-MM-DD') : null
        state.row_detail = row
    },
    SET_ACTIVE_BUTTON(state, promotion_id){
        for(let i in state.data_table){
            if(state.data_table[i].promotion_id == promotion_id){
                state.data_table[i].active_status = !state.data_table[i].active_status
            }
        }
    },
    SET_PROVIDER_LIST(state, data){
        state.provider = data
    },
    UPDATE_CR_STATUS(state, item){
        let index = state.data_table.findIndex(row => row.promotion_id == item.promotion_id)
        state.data_table[index].cr_remark = item.cr_remark
        state.data_table[index].cr_status = item.cr_status
    },
    BTN_DISABLE(state, status){
        state.btn_disable = status
    },
    SET_FILE_TYPE(state, type){
        state.fileType = type
    },
    SET_REGULATE_LIST(state, list){
        state.regulate_list = list
    }
}

export const Promotion = {
    namespaced: true,
    state,
    actions,
    mutations
}